export const CLOTHING_CATEGORY = "Ropa";

export const CHARGE_TYPE = {
  INDIVIDUAL: "individual",
  COLLECTIVE: "colectivo",
};

export const PAYMENT_METHOD = {
  BRAVOS: "bravos",
  CASH: "cash",
};

// Offset del navbar para que las pestañas de categoría no queden tapadas
// al hacer scroll. Ajusta este valor si cambia la altura de tu navbar.
export const STICKY_TABS_OFFSET = 56;
